<div class="container-fluid psp-container">
  <div class="card mb-4">
    <div class="row align-items-center pt-3">
      <div class="col-lg-6 col-7">
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
          <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
            <li class="breadcrumb-item text-primary psp-breadcrumb">
              <a class="text-primary" [routerLink]="'/patients'"> Patients </a>
            </li>
            <li class="breadcrumb-item text-primary psp-breadcrumb">
              <a class="text-primary" [routerLink]="'../'"> Patient Profile </a>
            </li>
            <li aria-current="page" class="breadcrumb-item active text-gray psp-breadcrumb">
              View Medication Requests
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="border-bottom title d-flex p-3 justify-content-between align-items-center mt-2">
      <h1 class="m-0">{{ patientName }} Medication Requests</h1>
    </div>

    <div class="title p-3" *ngIf="requests.recent.length > 0">
      <h2>Recent Medication Requests</h2>
    </div>

    <div class="table-responsive pt-0" *ngIf="requests.recent.length > 0">
      <table class="table align-items-center table-flush">
        <thead class="thead-light">
          <tr>
            <th *ngFor="let th of theadArray">{{ th }}</th>
          </tr>
        </thead>

        <tbody>
          <tr class="" *ngFor="let request of requests.recent">
            <td>
              <span>
                {{ request?.creationDate | date }}
              </span>
            </td>
            <td>
              <span>
                {{ request?.typeId == 1 ? "Home Delivery" : "Pick up" }}
              </span>
            </td>
            <td>
              <span [tooltip]="
                  request?.typeId == 1
                    ? request?.patientAddressData?.address
                    : request?.pharmacy?.name
                ">
                {{
                request?.typeId == 1
                ? request?.patientAddressData?.address?.length > 20
                ? (request?.patientAddressData?.address | slice: 0:25) + "..."
                : request?.patientAddressData?.address
                : request.pharmacy?.name
                }}
              </span>
            </td>
            <td>
              <span>
                {{ request?.discountField == true ? "Yes" : "No" }}
              </span>
            </td>
            <td>
              <span>
                {{ request?.theOrderQuantity == 0 || null ? "" : request?.theOrderQuantity  }}
              </span>
            </td>
            <td>
              <span>
                {{ request?.totalPublicPrice == 0 || null ? "" : request?.totalPublicPrice}}
              </span>
            </td>
            <td>
              <span>
                {{ request?.percentageOfTheDiscount == 0 || null ? "" : request?.percentageOfTheDiscount + '%'}}
              </span>
            </td>
            <td>
              <span>
                {{ request?.totalPriceAfterDiscount == 0 || null ? "" : request?.totalPriceAfterDiscount}}
              </span>
            </td>
            <td>
              <span *ngIf="!request?.discountField">
                {{ request?.freeOfChargeCount }}
              </span>
            </td>
            <td>
              <span *ngIf="!request?.discountField">
                {{ request?.emptyBoxesCount }}
              </span>
            </td>
            <td>
              <span *ngIf="!request?.discountField">
                {{ request?.purchasesCount }}
              </span>
            </td>
            <td>
              <span>
                {{
                request?.statusId == 1
                ? "Pending"
                : request?.statusId == 2
                ? "Confirmed"
                : ""
                }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <hr class="mb-0" *ngIf="requests.recent.length > 0" />

    <div class="title p-3 mt-2" *ngIf="requests.previous.length > 0">
      <h2>Previous Medication Requests</h2>
    </div>

    <div class="table-responsive pt-0" *ngIf="requests.previous.length > 0">
      <table class="table align-items-center table-flush">
        <thead class="thead-light">
          <tr>
            <th *ngFor="let th of theadArray">{{ th }}</th>
          </tr>
        </thead>

        <tbody>
          <tr class="" *ngFor="let request of requests.previous">
            <td>
              <span>
                {{ request?.creationDate | date }}
              </span>
            </td>
            <td>
              <span>
                {{ request?.typeId == 1 ? "Home Delivery" : "Pick up" }}
              </span>
            </td>
            <td>
              <span [tooltip]="
                  request?.typeId == 1
                    ? request?.patientAddressData?.address
                    : request?.pharmacy?.name
                ">
                {{
                request?.typeId == 1
                ? request?.patientAddressData?.address
                : request?.pharmacy?.name +
                " - " +
                request?.pharmacy?.address
                }}
              </span>
            </td>
            <td>
              <span>
                {{ request?.discountField == true ? "Yes" : "No" }}
              </span>
            </td>
            <td>
              <span>
                {{ request?.theOrderQuantity == 0 || null ? "" : request?.theOrderQuantity  }}
              </span>
            </td>
            <td>
              <span>
                {{ request?.totalPublicPrice == 0 || null ? "" : request?.totalPublicPrice}}
              </span>
            </td>
            <td>
              <span>
                {{ request?.percentageOfTheDiscount == 0 || null ? "" : request?.percentageOfTheDiscount + '%'}}
              </span>
            </td>
            <td>
              <span>
                {{ request?.totalPriceAfterDiscount == 0 || null ? "" : request?.totalPriceAfterDiscount}}
              </span>
            </td>
            <td>
              <span *ngIf="!request?.discountField">
                {{ request?.freeOfChargeCount }}
              </span>
            </td>
            <td>
              <span *ngIf="!request?.discountField">
                {{ request?.emptyBoxesCount }}
              </span>
            </td>
            <td>
              <span *ngIf="!request?.discountField">
                {{ request?.purchasesCount }}
              </span>
            </td>
            <td>
              <span>
                {{
                request?.statusId == 1
                ? "Pending"
                : request?.statusId == 2
                ? "Confirmed"
                : ""
                }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>